import { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, Input, Label, FormGroup } from 'reactstrap';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import {
    getLegacyPersonas
} from '../../slices/thunks';
import Flatpickr from "react-flatpickr";



const ModalModificarPersona = ({ isOpen, toggle, onSave, persona }) => {
    const tenantId = useSelector((state) => state.Context.tenantId)
    const empresa = useSelector((state) => state.Context.empresa)
    const departamento = useSelector((state) => state.Context.departamento)
    const userInfo = useSelector((state) => state.UserInfo.userInfo)
    const [formData, setFormData] = useState({
        rut: '',
        razon_social: '',
        giro: '',
        nombres: '',
        paterno: '',
        materno: '',
        direccion: '',
        comuna: '',
        ciudad: '',
        contacto: '',
        email: '',
        telefono: '',
        tipo_cliente: {},
        genero: {},
        fecha_nacimiento: ''

    });

    const dispatch = useDispatch()

    useEffect(() => {
        if (Object.keys(persona).length > 0) {
            if (typeof persona.CLIPRO == 'string') {
                formData.rut = persona.CLIPRO.trim().toUpperCase()
            }
            if (typeof persona.TPERSO == 'string') {
                let tipoCliente = persona.TPERSO.trim().toUpperCase()
                if (tipoCliente == "E") {
                    formData.tipo_cliente = {
                        label: "Persona Jurídica",
                        value: "E"
                    }
                } else {
                    formData.tipo_cliente = {
                        label: "Persona Natural",
                        value: "P"
                    }
                }
            }

            if (typeof persona.RAZSOC == 'string') {
                formData.razon_social = persona.RAZSOC.trim().toUpperCase()
            }
            if (typeof persona.ELGIRO == 'string') {
                formData.giro = persona.ELGIRO.trim().toUpperCase()
            }

            if (typeof persona.NOMNOM == 'string') {
                formData.nombres = persona.NOMNOM.trim().toUpperCase()
            }
            if (typeof persona.APEPAT == 'string') {
                formData.paterno = persona.APEPAT.trim().toUpperCase()
            }
            if (typeof persona.APEMAT == 'string') {
                formData.materno = persona.APEMAT.trim().toUpperCase()
            }
            if (typeof persona.CONTAC == 'string') {
                formData.contacto = persona.CONTAC.trim().toUpperCase()
            }
            if (typeof persona.CEMAIL == 'string') {
                formData.email = persona.CEMAIL.trim().toLowerCase()
            }
            if (typeof persona.NFONO1 == 'string') {
                formData.telefono = persona.NFONO1.trim().toUpperCase()
            }
            if (typeof persona.ELSEXO == 'string') {
                let genero = persona.ELSEXO.trim().toUpperCase()
                if (genero == "M") {
                    formData.genero = {
                        label: "Masculino",
                        value: "M"
                    }
                } else {
                    formData.genero = {
                        label: "Femenino",
                        value: "F"
                    }
                }
            }
            if (typeof persona.FECNAC == 'string' && persona.FECNAC.length > 10) {
                formData.fecha_nacimiento = persona.FECNAC.substring(0, 10);
            }
            if (typeof persona.DIRECC == 'string') {
                formData.direccion = persona.DIRECC.trim().toUpperCase()
            }
            if (typeof persona.COMUNA == 'string') {
                formData.comuna = persona.COMUNA.trim().toUpperCase()
            }
            if (typeof persona.CIUDAD == 'string') {
                formData.ciudad = persona.CIUDAD.trim().toUpperCase()
            }

        }
    }, [persona])

    const consultarInfoPersonas = () => {
        if (formData.rut && typeof formData.rut == 'string' && formData.rut.length > 5) {
            dispatch(getLegacyPersonas({ tenantId, rut: formData.rut }))
        }
    }

    const handleInputChange = (e) => {

        if (e?.target) {
            const { name, value } = e.target;
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleDateChangeNacimiento = (selectedDates) => {
        if (Array.isArray(selectedDates) && selectedDates.length > 0) {
            setFormData(prev => ({
                ...prev,
                ["fecha_nacimineto"]: selectedDates[0]
            }));
        }
    }
    const handleSelectGenero = (opcion) => {
        setFormData(prev => ({
            ...prev,
            ["genero"]: opcion
        }));
    }
    const handleTipoClienteChange = (opcion) => {
        setFormData(prev => ({
            ...prev,
            ["tipo_cliente"]: opcion
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
        toggle();
    };

    const handleCancel = () => {
        toggle();
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                Cliente
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    <div className="row">
                        <div className="col-6">
                            <FormGroup>
                                <Label for="rut">Rut</Label>
                                <Input
                                    type="text"
                                    id="rut"
                                    name="rut"
                                    value={formData.rut}
                                    onChange={handleInputChange}
                                    placeholder="Ej: 78123456-7"
                                />
                            </FormGroup>
                        </div>
                        <div className="col-6">
                            <FormGroup>
                                <Label for="tipo_cliente">Tipo cliente</Label>
                                <Select
                                    id="tipo_cliente"
                                    value={formData.tipo_cliente}
                                    onChange={(opcion) => { handleTipoClienteChange(opcion) }}
                                    options={[
                                        {
                                            label: "Persona Natural",
                                            value: "P"
                                        },
                                        {
                                            label: "Persona Jurídica",
                                            value: "E"
                                        }
                                    ]}
                                    onFocus={(e) => {
                                        e.target.readOnly = true;
                                    }}
                                />
                            </FormGroup>
                        </div>
                    </div>
                    {formData.tipo_cliente && formData.tipo_cliente.value == "E" ? (
                        <>
                            <div className="row">
                                <div className="col-12">
                                    <FormGroup>
                                        <Label for="nombres">Razon social</Label>
                                        <Input
                                            type="text"
                                            id="nombres"
                                            name="nombres"
                                            value={formData.razon_social}
                                            onChange={handleInputChange}
                                            placeholder="Ej: Siga Ltda"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <FormGroup>
                                        <Label for="giro">Giro</Label>
                                        <Input
                                            type="text"
                                            id="giro"
                                            name="giro"
                                            value={formData.giro}
                                            onChange={handleInputChange}
                                            placeholder="Ej: Consultoría Informática"
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="row">
                                <div className="col-12">
                                    <FormGroup>
                                        <Label for="nombres">Nombres</Label>
                                        <Input
                                            type="text"
                                            id="nombres"
                                            name="nombres"
                                            value={formData.nombres}
                                            onChange={handleInputChange}
                                            placeholder="Ej: Jorge Miguel"
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="paterno">Ap. Paterno</Label>
                                        <Input
                                            type="text"
                                            id="paterno"
                                            name="paterno"
                                            value={formData.paterno}
                                            onChange={handleInputChange}
                                            placeholder="Ej: Gonzalez"
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="materno">Ap. Materno</Label>
                                        <Input
                                            type="text"
                                            id="materno"
                                            name="materno"
                                            value={formData.materno}
                                            onChange={handleInputChange}
                                            placeholder="Ej: Tapia"
                                            required
                                        />
                                    </FormGroup>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="nacimiento">Fecha nacimiento</Label>
                                        <Flatpickr
                                            id="nacimiento"
                                            className="form-control"
                                            options={{
                                                mode: "single",
                                                dateFormat: "Y-m-d",
                                                maxDate: "today",
                                            }}
                                            value={formData.fecha_nacimiento}
                                            onChange={handleDateChangeNacimiento}
                                        />
                                    </FormGroup>
                                </div>
                                <div className="col-6">
                                    <FormGroup>
                                        <Label for="genero">Género</Label>
                                        <Select
                                            id="genero"
                                            placeholder="Seleccione..."
                                            value={formData.genero}
                                            onChange={(opcion) => {
                                                handleSelectGenero(opcion);
                                            }}
                                            options={[
                                                { value: "M", label: 'Masculino' },
                                                { value: "F", label: 'Femenino' },]}
                                            onFocus={(e) => {
                                                e.target.readOnly = true;
                                            }}
                                        />
                                    </FormGroup>
                                </div>
                            </div>
                        </>)}

                    <div className="d-flex align-items-center my-4">
                        <div className="flex-grow-1 border-top"></div>
                        <span className="mx-3 text-muted">Datos de contacto</span>
                        <div className="flex-grow-1 border-top"></div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <FormGroup>
                                <Label for="calle">Direccion</Label>
                                <Input
                                    type="text"
                                    id="direccion"
                                    name="direccion"
                                    value={formData.direccion}
                                    onChange={handleInputChange}
                                    placeholder="Ej: Arturo Prat 390 Of. 1302"
                                />
                            </FormGroup>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <FormGroup>
                                <Label for="comuna">Comuna</Label>
                                <Input
                                    type="text"
                                    id="comuna"
                                    name="comuna"
                                    value={formData.comuna}
                                    onChange={handleInputChange}
                                    placeholder="Ej: Biobío"
                                />
                            </FormGroup>
                        </div>
                        <div className="col-6">
                            <FormGroup>
                                <Label for="ciudad">Ciudad</Label>
                                <Input
                                    type="text"
                                    id="ciudad"
                                    name="ciudad"
                                    value={formData.ciudad}
                                    onChange={handleInputChange}
                                    placeholder="Ej: Concepción"
                                    required
                                />
                            </FormGroup>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <FormGroup>
                                <Label for="email">Email</Label>
                                <Input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="Ej: correo@ejemplo.cl"
                                />
                            </FormGroup>
                        </div>
                        <div className="col-6">
                            <FormGroup>
                                <Label for="celular">Celular</Label>
                                <Input
                                    type="number"
                                    id="celular"
                                    name="celular"
                                    value={formData.telefono}
                                    onChange={handleInputChange}
                                    placeholder="Ej: 987654321"
                                    required
                                />
                            </FormGroup>
                        </div>
                    </div>



                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-light" onClick={handleCancel}>
                        Cancelar
                    </button>
                    <button type="submit" className="btn btn-success">
                        <i className="ri-save-line me-1"></i>
                        Guardar
                    </button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default ModalModificarPersona;